import React, { useContext } from 'react';
import { IconButton, Typography } from 'fronton-react';
import { PencilSimpleIcon, XIcon } from '@fronton/icons-react';
import { useTintColor } from 'pages/calculation/hooks/use-tint-color.hook';
import { useTintServiceState } from 'pages/calculation/store/tint-service';
import { DataContext } from 'entries/common/widgets/context';
import {
  COLORING_IMAGE_HEIGHT,
  COLORING_IMAGE_WIDTH,
  COLORING_IMAGE_URL,
} from 'pages/calculation/consts/coloring-image-attributes.consts';
import { getColoringName } from 'pages/calculation/helpers/get-coloring-name.helper';
import { ColoringPrice } from './coloring-price/coloring-price';
import { ColoringCode } from './coloring-code/coloring-code';
import { root, wrapper, top, left, imgCol, imgWrapper, right, actions, centerCol } from './styles';

export const Coloring = () => {
  const data = useContext(DataContext);
  const {
    selectedColor,
    setSelectedTintColor,
    deleteColorFromSelected,
    isTintServiceAvailable,
    setIsTintServiceAvailable,
  } = useTintServiceState();
  const { openChooseColorModal, handleDeleteColor } = useTintColor({
    setSelectedTintColor,
    deleteColorFromSelected,
    isTintServiceAvailable,
    setIsTintServiceAvailable,
  });
  const name = getColoringName(selectedColor);

  return (
    <div className={root} data-testid="coloring-container">
      <div className={wrapper}>
        <div className={top}>
          <div className={left}>
            <div className={imgCol}>
              <div className={imgWrapper}>
                <img
                  src={COLORING_IMAGE_URL}
                  width={COLORING_IMAGE_WIDTH}
                  height={COLORING_IMAGE_HEIGHT}
                  alt={name}
                />
              </div>
            </div>

            <div className={centerCol}>
              <div>
                <ColoringCode value={data?.productId ?? '-'} />
              </div>
              <div>
                <Typography color="text-primary" variant="m" size="body_long" data-testid="coloring-name">
                  {name}
                </Typography>
              </div>
              <div className={actions}>
                <IconButton
                  data-testid="change-tint-button"
                  onClick={openChooseColorModal}
                  label="Изменить колеровку"
                  size="m"
                  variant="secondary">
                  <PencilSimpleIcon strokeWidth={1.25} />
                </IconButton>
                <IconButton
                  data-testid="remove-tint-button"
                  onClick={handleDeleteColor}
                  label="Удалить колеровку"
                  size="m"
                  variant="secondary">
                  <XIcon strokeWidth={1.25} />
                </IconButton>
              </div>
            </div>
          </div>
          <div className={right}>
            <ColoringPrice />
          </div>
        </div>
      </div>
    </div>
  );
};
